import React, {useEffect, useState, useMemo} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
// import Skills from "./skills/Skills";
// import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
// import Projects from "./projects/Projects";
// import StartupProject from "./StartupProjects/StartupProject";
// import Achievement from "./achievement/Achievement";
// import Blogs from "./blogs/Blogs";
import Footer from "../components/footer/Footer";
// import Talks from "./talks/Talks";
// import Podcast from "./podcast/Podcast";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
// import Twitter from "./twitter-embed/twitter";
// import Profile from "./profile/Profile";
import Contact from "./contact/Contact";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";

const Main = () => {
  const darkMediaQuery = useMemo(() => window.matchMedia("(prefers-color-scheme: dark)"), []);
  
  // 1. Check if we already have a saved preference in localStorage
  const [isDark, setIsDark] = useLocalStorage("isDark", darkMediaQuery.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] = useState(true);

  // 2. LISTEN FOR SYSTEM CHANGES (With "Override" protection)
  useEffect(() => {
    const handler = (e) => {
      // Only auto-update if the user hasn't explicitly set a preference in this session
      // Or, if you want it to always follow system, keep it as is. 
      // Most modern apps follow the system unless the user clicks the toggle.
      const userHasSetPreference = localStorage.getItem("isDark") !== null;
      
      if (!userHasSetPreference) {
        setIsDark(e.matches);
      }
    };

    darkMediaQuery.addEventListener("change", handler);
    return () => darkMediaQuery.removeEventListener("change", handler);
  }, [darkMediaQuery, setIsDark]);

  // 3. APPLY CLASSES TO BODY
  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDark]);

  // 4. SPLASH TIMER
  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(() => setIsShowingSplashAnimation(false), splashScreen.duration);
      return () => clearTimeout(splashTimer);
    }
    setIsShowingSplashAnimation(false);
  }, []);

  const changeTheme = () => setIsDark(!isDark);

  return (
    <StyleProvider value={{ isDark, changeTheme }}>
      {isShowingSplashAnimation && splashScreen.enabled ? (
        <SplashScreen />
      ) : (
        <div className="portfolio-layout">
          <Header />
          {/* Key helps re-trigger entrance animations if needed */}
          <main className="main-content-area" key={isDark ? "dark" : "light"}>
            <Greeting />
            {/* <Skills /> */}
            {/* <StackProgress /> */}
            <WorkExperience />
            <Education />
            {/* <StartupProject /> */}
            {/* <Achievement /> */}
            {/* <Talks /> */}
            {/* <Twitter /> */}
            {/* <Podcast /> */}
            <Contact />
            <Footer />
          </main>
          <ScrollToTopButton />
        </div>
      )}
    </StyleProvider>
  );
};

export default Main;
